import { render, staticRenderFns } from "./upgrade1.vue?vue&type=template&id=711f6596&scoped=true&"
import script from "./upgrade1.vue?vue&type=script&lang=js&"
export * from "./upgrade1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f6596",
  null
  
)

export default component.exports